import React, { forwardRef } from 'react';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';
import { PassengersPageId } from '../../../app/pages/domain/constants/PageId';
import { useUrlForPageId } from '../../../app/pages/ui/utils/useUrlForPageId';
import { Checkbox, ICheckboxProps } from '../../../../ui';

export const TermsAndConditionsCheckboxLabel = () => {
	const { t } = useTranslation();

	const termsAndConditionsUrl = useUrlForPageId(
		PassengersPageId.TermsAndConditions,
	);
	const privacyPolicyUrl = useUrlForPageId(PassengersPageId.PrivacyPolicy);

	const srOnly =
		'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0';
	const externalLinkLabel = t('generic_external_link_label');

	const linkStyle =
		'text-decoration:underline; font-weight: 600; border-radius: 4px;';

	const html = t('user_sign_up_consent_label', {
		terms_and_conditions_link: `<a class="consent-link" style="${linkStyle}" target="_blank" href=${termsAndConditionsUrl}>${t(
			'user_sign_up_terms_and_conditions_label',
		)}<span style="${srOnly}"> (${externalLinkLabel})</span></a>`,
		privacy_policy_link: `<a class="consent-link" style="${linkStyle}" target="_blank" href=${privacyPolicyUrl}>${t(
			'user_sign_up_privacy_policy_label',
		)}<span style="${srOnly}"> (${externalLinkLabel})</span></a>`,
		interpolation: {
			escapeValue: false,
		},
	});

	const styledHtml = `<style>.consent-link:hover{outline:0;color:#FFFFFF;background-color:#0077C8;padding:0.125rem 0.5rem}.consent-link:focus-visible{color:#FFFFFF;background-color:#0077C8;outline:solid 2px #430042;border-radius:4px;outline-offset:-2px;padding:0.125rem 0.5rem}</style>${html}`;

	// eslint-disable-next-line react/no-danger, @typescript-eslint/naming-convention
	return <div dangerouslySetInnerHTML={{ __html: styledHtml }} />;
};

export type ITermsAndConditionsCheckboxProps = Omit<ICheckboxProps, 'label'>;

export const TermsAndConditionsCheckbox = forwardRef<
	HTMLInputElement,
	ITermsAndConditionsCheckboxProps
>((props: ITermsAndConditionsCheckboxProps, ref) => (
	<Checkbox
		label={<TermsAndConditionsCheckboxLabel />}
		{...props}
		ref={ref}
		required
	/>
));
